export const useActiveEntity = () => useState<any>('active-entity', () => null)
